import React from 'react';
import './no-question-massage.scss';
import { description_MassageIfNoQuestionApplicantWise, header_MassageIfNoQuestionApplicantWise, } from '../../../shared/types/constants';
var NoQuestionMassage = function () {
    return (React.createElement("div", { className: "c-no-question-message" },
        React.createElement("div", null,
            React.createElement("p", { className: "p" },
                React.createElement("strong", null, header_MassageIfNoQuestionApplicantWise)),
            React.createElement("span", null,
                React.createElement("p", null, description_MassageIfNoQuestionApplicantWise)))));
};
export default NoQuestionMassage;
